import React from 'react';
import { Menu, MenuItem, Typography, Button, ListItemText } from '@mui/material';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import AddIcon from '@mui/icons-material/Add';
import MessageIcon from '@mui/icons-material/Message';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import Groups3Icon from '@mui/icons-material/Groups3';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { useTranslation } from "react-i18next";
import "../../css/components/Topbar/NotificationMenu.css";

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const NotificationMenu = ({
    anchorEl,
    open,
    onClose,
    unreadNotifications,
    handleNotificationClick,
    FormatTimestamp,
    handleMarkAllAsRead,
    handleWorkspaceInvite
}) => {
    const { t } = useTranslation();

    const getIconAndColor = (notification) => {
        let icon, color;

        switch (notification.option_select) {
            case 'Vacation-Accepted':
                icon = <EventAvailableIcon />;
                color = 'green';
                break;
            case 'Vacation-Declined':
                icon = <EventBusyIcon />;
                color = 'red';
                break;
            case 'Vacation-Refuted':
                icon = <EventRepeatIcon />;
                color = 'orange';
                break;
            default:
                if (notification.type === 'Event' && !notification.option_select) {
                    icon = <Groups3Icon />;
                    color = 'blue';
                } else if (notification.type === 'Vacation' && !notification.option_select) {
                    icon = <EventNoteIcon />;
                    color = 'black';
                } else {
                    switch (notification.type) {
                        case 'Workspace':
                            icon = <WorkspacesIcon />;
                            color = 'black';
                            break;
                        case 'Project':
                            icon = <AccountTreeIcon />;
                            color = 'black';
                            break;
                        case 'Task':
                            icon = <AssignmentIcon />;
                            color = 'black';
                            break;
                        case 'Mention':
                            icon = <AlternateEmailIcon />;
                            color = 'black';
                            break;
                        case 'Reply':
                            icon = <MessageIcon />;
                            color = 'black';
                            break;
                        default:
                            icon = <MarkEmailUnreadIcon />;
                            color = 'black';
                            break;
                    }
                }
        }

        return { icon, color };
    };


    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
        >
            {[...unreadNotifications].slice(0, 5).map((notification) => {
                const { icon, color } = getIconAndColor(notification);

                return (
                    <MenuItem key={notification.id} onClick={() => {
                        handleNotificationClick(notification);
                        onClose(); 
                      }}>
                        <div style={{ marginRight: '5px', color }}>
                            {icon}
                        </div>
                        <ListItemText
                            className="notification-text"
                            sx={{ color }}
                            primary={<Typography variant="body1" style={{ color }}>{notification.message}</Typography>}
                            secondary={
                                <Typography variant="body2" style={{ color: '#67B5D9' }}>
                                    <AccessTimeIcon fontSize="inherit" /> {FormatTimestamp(notification.timestamp)}
                                    {notification.workspace && (
                                        " - " + notification.workspace
                                    )}
                                </Typography>
                            }
                        />
                        {notification.option_select === 'Workspace-Invite' && (
                            <>
                                <Button
                                    variant="contained"
                                    className="accept-button vacation-approval-buttons-margin"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();  // Stop the click from propagating to the MenuItem
                                        handleWorkspaceInvite(notification, true);
                                    }}
                                >
                                    <CheckCircleIcon />
                                </Button>
                                <Button
                                    variant="contained"
                                    className="decline-button vacation-approval-buttons-margin"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();  // Stop the click from propagating to the MenuItem
                                        handleWorkspaceInvite(notification, false);
                                    }}
                                >
                                    <CancelIcon />
                                </Button>
                            </>
                        )}
                        {/* This here is for the POST accept/decline of the invites */}
                        {notification.option_select === 'Workspace-Invite-Accepted' && (
                            <Button
                                variant="contained"
                                className="accepted-button vacation-approval-buttons-margin"
                            >
                                <CheckCircleIcon />
                            </Button>
                        )}
                        {notification.option_select === 'Workspace-Invite-Declined' && (
                            <Button
                                variant="contained"
                                className="declined-button vacation-approval-buttons-margin"
                            >
                                <CancelIcon />
                            </Button>
                        )}
                        <MarkEmailUnreadIcon className="notification-unread-icon" />
                    </MenuItem>

                );
            })}
            {unreadNotifications.length === 0 && (
                <Typography variant="body1" className="notification-no-notifs">
                    {t("topbar.no_notifs")}
                </Typography>
            )}
            <div style={{ display: "flex", justifyContent: unreadNotifications.length > 0 ? "space-between" : "center", }}>

                {unreadNotifications.length > 0 && (
                    <Button className="notification-mark-all-read" onClick={() => handleMarkAllAsRead()}>
                        {t("topbar.mark_all_as_read")} <MarkEmailReadIcon fontSize="medium" sx={{ ml:1 }} />
                    </Button>
                )}

                <a href="/workflow/notifications">
                    <Button className="notification-view-all">
                        {t("topbar.view_all_notifs")} <AddIcon fontSize="medium" sx={{color: '#D6D4D4' }} />
                    </Button>
                </a>

            </div>

        </Menu>
    );

};

export default NotificationMenu;
